<template>
  <div v-if="term !== ''" class="search-result-dropdown overflow-y-auto bg-white border
  border-gray border-opacity-0 shadow-lg lg:w-600 w-full absolute lg:right-0 lg:mt-22 z-10">
    <ul class="mt-4">
      <li
        v-for="result in results"
        class="cursor-pointer px-12 py-8 text-16 hover:bg-light-gray transition duration-300"
        @click="goTo(result)">
        <h2>{{ result.text }}</h2>
        <span class="text-dark-gray text-14">{{ result.type }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import Result from "./Result.vue";

export default {
  extends: Result,

  data () {
    return {
      link: '/web/api/search',
    }
  },
}
</script>
